import React from "react";
import {
  parseAmount,
  CURRENCY_EURO,
  parsePrepaidCardCode,
  prepaidCardColorAmount
} from "../../utils/utils";
import I18n from "i18n-js";




const PrepaidCardDetails = ({
 prepaidCard,
 isSuperMiddleman
}) => {

  return (
    <div className="d-flex justify-content-end flex-wrap align-items-center px-0 px-md-2">
      {
        isSuperMiddleman && prepaidCard.middleman &&
        <div
          className="bg-aiG-gray2-imp br-50px mr-1 mr-lg-3 px-2 py-1 my-1 d-none middleman-label justify-content-center text-center align-items-center">
          <span>{prepaidCard.middleman}</span>
        </div>
      }

      <div
        className="bg-aiG-gray2-imp br-50px mx-1 mx-lg-3 px-2 px-lg-3 py-1 my-1 d-flex justify-content-center text-center align-items-center">
        <span className="d-none d-md-flex">{I18n.t('js.indexPrepaidCards.code')}:&nbsp;</span>
        <b>{parsePrepaidCardCode(prepaidCard.code)}</b>
      </div>

      {
        prepaidCard.created_at &&
        <div
          className="bg-aiG-gray2-imp br-50px mx-1 mx-lg-3 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
          <img src={window.location.origin + '/images/icons/small/calendar.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span className="d-none d-xl-flex">{I18n.t('js.indexPrepaidCards.activationDate')}:&nbsp;</span>
          <b>{prepaidCard.created_at}</b>
        </div>
      }

      <div
        className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-3 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
        <span className="d-none d-md-flex">{I18n.t('js.indexPrepaidCards.middlemanFee')}:&nbsp;</span>
        <b>{parseAmount(prepaidCard.middleman_fee, 2)}{CURRENCY_EURO}</b>
      </div>
    </div>
  )
}


const PrepaidCardList = ({
   prepaidCards,
   prepaidCardsAnimationDivider,
   isSuperMiddleman
 }) => {


  return (
    <div className="row w-100 p-0 mx-0 mt-0 mb-5">
      {prepaidCards.map((prepaidCard, i) =>
        <div key={prepaidCard.id} id={prepaidCard.id}
             className={`submission_list_container
                        col-12
                        d-block d-md-flex my-3 px-3 px-md-0`}
            //  style={{ animation: `scale-up 0.5s ease-out ${0.100 * (i % prepaidCardsAnimationDivider)}s forwards` }}
        >
          <div className="w-100 p-0">
            <div className="row w-100 p-0 m-0 align-items-center border-aiG-light-gray-imp br-8px">
              <div className="col-8 col-sm-10 col-lg-1 d-flex justify-content-start
                                px-0 align-items-center minH-42px-imp z-index-10
                                br-top-left-8px br-bottom-left-0px br-bottom-right-8px
                                br-bottom-left-md-8px br-bottom-right-md-0px"
              >
                <img src={window.location.origin + `/images/icons/credit-card-solid.svg`}
                     style={{ maxHeight: "42px" }}
                     className="m-0 p-0"
                     alt=""/>
              </div>

              <div className={`d-none d-lg-flex justify-content-end col-lg-10 z-index-10 px-0`}>
                <PrepaidCardDetails
                  prepaidCard={prepaidCard}
                  isSuperMiddleman={isSuperMiddleman}
                />
              </div>

              <div className={`col-4 col-sm-2 col-lg-1 px-0 color-white d-flex justify-content-center align-items-center text-center minH-42px-imp z-index-10 text-truncate
                                            br-top-right-8px br-bottom-left-8px br-bottom-right-0px
                                            br-bottom-left-md-0px br-bottom-right-md-8px text-line-height-09`}
                   style={{ backgroundColor: prepaidCardColorAmount(prepaidCard.amount) }}>
                <div className="my-0 py-0">
                  <p className="my-0 py-0">
                    <b className="color-white text-truncate">
                      {parseAmount(prepaidCard.amount, 0)}{CURRENCY_EURO}
                    </b>
                  </p>
                  <p className="my-0 py-0">
                    <small>{I18n.t('js.indexPrepaidCards.amount')}</small>
                  </p>
                </div>
              </div>

              <div className="col-12 d-lg-none py-2 pr-1">
                <PrepaidCardDetails
                  prepaidCard={prepaidCard}
                  isSuperMiddleman={isSuperMiddleman}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrepaidCardList;